<template>
  <div class="survey-progress">
    <div class="col">
    {{currentQuestion}} out of {{totalQuestions}} Questions Answered
    <v-progress-linear
      color="success"
      height="10"
      :value="percentComplete"
    ></v-progress-linear>
    </div>
  </div>
</template>

<script>
export default {
  props: ["currentQuestion", "totalQuestions"],
  computed: {
    percentComplete() {
      return Math.floor(this.currentQuestion / this.totalQuestions * 100)
    }
  }
}
</script>

<style lang="less" scoped>
.survey-progress {
  position:  sticky;
  bottom: 0;
  background-color: black;
  color: white;
  height: 40px;
  display: flex;
  justify-content: center;
  font-weight: 600;
  align-items: center;
  .v-progress-linear {
    margin: 0px !important;
  }

  .hide-xs {
    @media (max-width: 440px) {
      display: none;
    }
  }

  .col {
    display: flex;
    flex-direction: column;
  }
};

</style>
